import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { L1L3AuthService, UserInfo } from 'ngx-auth-util-lib';
import { DomainType, HekaAccountMenu, MultiDomainProfile } from 'ngx-heka-design-lib';
import { UtilService } from './util.service';
import { environment } from '../../environments/local/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountMenuService {
    private _userInfoChanged = new BehaviorSubject<UserInfo | null>(null);


  constructor(
    private authService: L1L3AuthService,
    private translateService: TranslateService,
    private utilService: UtilService
  ) {
    authService.isAuthenticatedSubject.subscribe({
      next: isAuthenticated => {
        if (isAuthenticated) {
          const userInfo = this.authService.getUserInfo();
          this.userInfoChanged.next(userInfo);
        }
      }
    });

  }
  get userInfoChanged(): BehaviorSubject<UserInfo | null> {
    return this._userInfoChanged;
  }

  public buildAccountMenu(profile: MultiDomainProfile): HekaAccountMenu {
    const userInfo = this.authService.getUserInfo();
    const currentProfile = profile.domains.find(d => d.active);
    const validDomains = profile.domains.filter(d => d.domainType == DomainType.JOINED);

    return {
      companyName: currentProfile?.companyName || '',
      userFullName: userInfo.display_name,
      userEmail: userInfo.email,
      userDomains: validDomains,
       help: {
        label: this.translateService.instant('ACCOUNT_MENU.HELP'),
        clickHandler: () =>
          this.utilService.goToLink(environment.links.help)
      },

      profile: {
        label: this.translateService.instant('ACCOUNT_MENU.PROFILE'),
        clickHandler: () => this.authService.goToProfile()
      },
      domains: {
        label: this.translateService.instant('ACCOUNT_MENU.DOMAINS'),
        clickHandler: () =>
          (window.location.href = environment.links.applications.l2.host + environment.links.applications.l2.domains)
      },
      imprint: {
        label: this.translateService.instant('ACCOUNT_MENU.IMPRINT'),
        clickHandler: () =>
          this.utilService.goToLink(
            environment.links.applications.mh2.host + environment.imprint.endpoint.paths.imprint
          )
      },
      logout: {
        label: this.translateService.instant('ACCOUNT_MENU.LOGOUT'),
        clickHandler: () => this.authService.logout()
      }
    };
  }
}
